import type { ReactNode } from 'react';
import { cx } from '../internal/tone';

export interface SectionHeadingProps {
  children: ReactNode;
  className?: string;
}

/** Cabeçalho de seção. É um <h2> para o leitor de tela poder saltar entre seções. */
export function SectionHeading({ children, className }: SectionHeadingProps) {
  return <h2 className={cx('flos-section-heading', className)}>{children}</h2>;
}
